import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const save: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="save_icon" data-name="save icon" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <g id="Group_4097" data-name="Group 4097" transform="translate(-19740.637 -3525.664)">
        <path
          id="Path_7065"
          data-name="Path 7065"
          d="M1.794,17.893A1.8,1.8,0,0,1,0,16.1V1.794A1.8,1.8,0,0,1,1.794,0H14.112a.6.6,0,0,1,.426.176l3.179,3.179a.6.6,0,0,1,.176.426V16.1A1.8,1.8,0,0,1,16.1,17.893Zm14.3-1.2a.59.59,0,0,0,.59-.59V4.03L13.919,1.261V5.768a1.8,1.8,0,0,1-1.794,1.794H4.973A1.8,1.8,0,0,1,3.179,5.768V1.2H1.794a.59.59,0,0,0-.59.59V16.1a.59.59,0,0,0,.59.59h.59V9.344a.6.6,0,0,1,.6-.6h11.92a.6.6,0,0,1,.6.6v7.345ZM14.3,9.946H3.588v6.742H14.3ZM4.383,5.768a.59.59,0,0,0,.59.59h7.152a.59.59,0,0,0,.59-.59V1.2H4.383Z"
          transform="translate(1286 583.342)"
          fill="currentColor"
        />
        <path
          id="Path_7066"
          data-name="Path 7066"
          d="M234.92,38.787H233.33a.6.6,0,0,0-.6.6v3.179a.6.6,0,0,0,.6.6h1.589a.6.6,0,0,0,.6-.6V39.389a.6.6,0,0,0-.6-.6m-.4,3.384h-.795V39.787h.795Z"
          transform="translate(1062.808 546.144)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
};
